module.exports = __webpack_public_path__ + "img/pic_empty.e86ec155.png";